import React from 'react'

const TriggerHeader = ({ title }) => {
	return (
		<div className="filter-accordion__header">
			<span className="filter-accordion__title">{title}</span>
		</div>
	)
}

export default TriggerHeader
